import React from "react";
import "../css/tableLayout.css";
import moment from "moment";
import { isValidUrl } from "../../new_appointment/_helper/utils.js/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getImageURL } from "../../_helper/utils/image";

const TableLayout = ({ data, handlePatientDetails }) => {
  const [searchParams] = useSearchParams();
  const allClinic = searchParams.get("all_clinic");
  const navigate = useNavigate();
  return (
    <div className="cu-table-layout-main ">
      <table className="cu-all-patient-table-layout">
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>Patient Name</th>
            <th>Age</th>
            <th>Gender</th>
            <th>Phone Number</th>
            <th>Last Appointment</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, i) => (
            <tr key={i}>
              <td className="cu-table-layout-head-name">
                <div className="cu-table-layout-head-span rounded overflow-hidden">
                  {item?.profile_image &&
                  isValidUrl(getImageURL(item?.profile_image)) ? (
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={getImageURL(item?.profile_image)}
                      alt=""
                    />
                  ) : (
                    <div className="bg-[#C7EAC9] w-full h-full uppercase text-white flex justify-center items-center">
                      {item?.full_name.split("")[0]}
                    </div>
                  )}
                </div>
                <div
                  className="cu-table-head-full-name cursor-pointer"
                  onClick={() =>
                    // navigate(`/new/all-patient/${item?.id}?option=profile&all_clinic=${allClinic}`)
                    handlePatientDetails(item?.id)
                  }
                >
                  {item?.full_name}
                </div>
              </td>
              <td>{moment().diff(item.dob, "years")} years</td>
              <td>{item?.gender}</td>
              <td>{item?.phone}</td>
              <td>
                {item?.date_updated
                  ? moment(item?.date_updated).format("DD MMM yyyy")
                  : "--"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableLayout;
